<template>
  <main>
    <div class="row center-align main">
      <span class="titulo center-align">Monto minimo para notificar.</span>
      <div class="col card-panel recargas">
        <span class="subtitulo center-align">Recargatodo</span>
        <input  type="number" v-model="recargatodo">
      </div>
      <div class="col card-panel movimientos">
        <span class="subtitulo center-align">Pagaqui</span>
        <input  type="number" v-model="pagaqui">
      </div>
      <a class="btn-floating btn-large waves-effect waves-light blue-grey darken-3" @click="actualizar"><i class="material-icons">save</i></a>
    </div>
  </main>
</template>

<script>
  import {patchMinimos,getMinimos} from '@/api/api'

  export default {
    name: "saldos",
    data() {
      return {
        recargatodo:'',
        pagaqui:'',
      }
    },
    mounted(){
      getMinimos().then(res=>{
        const auxMinimos = res.data.minimos
        this.recargatodo = auxMinimos.find(minimo=>minimo.id==='1').minimo
        this.pagaqui = auxMinimos.find(minimo=>minimo.id==='2').minimo
      }).catch(error=>{
        console.log(error)
      })
    },
    methods:{
      actualizar(){
        if (this.recargatodo.length<1 || this.pagaqui.length<1)M.toast({html: 'Ningun monto puede ir vacio', classes: 'rounded', displayLength: 4000})
        patchMinimos([{id:'1',minimo:this.recargatodo},{id:'2',minimo:this.pagaqui}]).then(res=>{
          M.toast({html: 'Actualizado correctamente', classes: 'rounded', displayLength: 4000})
        }).catch(error=>{
          console.log(error)
          M.toast({html: 'Error actualizando, intente mas tarde', classes: 'rounded', displayLength: 4000})
        })
      }
    },
    beforeCreate:function(){
      if (localStorage.nivel > 1) return this.$router.push({name:'login'})
    }
  }
</script>

<style scoped>
  .titulo {
    font-size: 2.2em;
    display: block;
    margin-top: 5px;
    font-family: "Roboto",serif;
    font-weight: lighter;
  }

  .subtitulo {
    font-size: 2em;
    display: block;
    margin-top: 5px;
    font-family: "Roboto Thin", serif;
  }

  .btn-floating{
    margin-top: 25px;
  }

  .card-panel {
    margin-top: 25px;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .recargas{
    width: 45.5%;
    margin-left: 3%;
  }

  .movimientos{
    width: 45.5%;
    margin-left: 3%;
  }

  .main{
    margin-top: 20px;
  }
</style>
